import React from 'react';
import { Check, X } from 'lucide-react';
import { ScrollFadeIn } from './ScrollFadeIn';
const forWho = ["High-achievers 40+ who feel 'wired' at night and 'dead' in the morning.", "Anyone struggling with stubborn midsection fat that doesn't respond to traditional exercise.", 'People who wake up between 2 AM and 4 AM with a racing heart or racing thoughts.', "Professionals experiencing 'Brain Fog' and cognitive fatigue during the workday."];
const notForWho = ["People looking for a 'magic weight loss pill' without changing their nightly habits.", "Those under 30 whose hormones are still in peak 'recovery mode.'", 'Anyone unwilling to spend 7 minutes a night on a simple physical routine.'];
export function AudienceSection() {
  return <section className="py-24 bg-slate-900" data-id="element-1">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-3">
          {/* Who this is for */}
          <ScrollFadeIn direction="right" data-id="element-4">
            <div className="bg-slate-800/50 border border-emerald-500/20 p-8 rounded-2xl h-full" data-id="element-5">
              <h3 className="text-2xl font-serif text-slate-50 mb-8 flex items-center" data-id="element-6">
                <span className="bg-emerald-500/10 text-emerald-400 p-2 rounded-lg mr-4" data-id="element-7">
                  <Check className="w-6 h-6" data-id="element-8" />
                </span>
                Who This Is For
              </h3>
              <ul className="space-y-6" data-id="element-9">
                {forWho.map((item, index) => <li key={index} className="flex items-start" data-id="element-10">
                    <Check className="w-5 h-5 text-emerald-400 mr-3 shrink-0 mt-0.5" data-id="element-11" />
                    <span className="text-slate-300 leading-relaxed" data-id="element-12">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </ScrollFadeIn>

          {/* Who this is NOT for */}
          <ScrollFadeIn direction="left" delay={0.2} data-id="element-13">
            <div className="bg-slate-800/50 border border-rose-500/20 p-8 rounded-2xl h-full" data-id="element-14">
              <h3 className="text-2xl font-serif text-slate-50 mb-8 flex items-center" data-id="element-15">
                <span className="bg-rose-500/10 text-rose-400 p-2 rounded-lg mr-4" data-id="element-16">
                  <X className="w-6 h-6" data-id="element-17" />
                </span>
                Who This Is NOT For
              </h3>
              <ul className="space-y-6" data-id="element-18">
                {notForWho.map((item, index) => <li key={index} className="flex items-start" data-id="element-19">
                    <X className="w-5 h-5 text-rose-400 mr-3 shrink-0 mt-0.5" data-id="element-20" />
                    <span className="text-slate-300 leading-relaxed" data-id="element-21">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </ScrollFadeIn>
        </div>
      </div>
    </section>;
}